import classNames from 'classnames';
import { useCallback } from 'react';
import Flex, { FlexProps } from '../Flex';

import './index.css';

export interface RippleProps extends FlexProps {
  rippleColor?: string;
}

export function Ripple({
  onClick,
  className,
  children,
  rippleColor = 'rgba(185, 185, 185, 0.1)',
  ...rest
}: RippleProps) {

  const createRipple = useCallback((event: any) => {
    const target = event.currentTarget;
    const circle = document.createElement('span');
    const diameter = Math.max(target.clientWidth, target.clientHeight);
    const radius = diameter / 2;
    circle.style.width = circle.style.height = `${diameter}px`;
    circle.style.left = `${event.clientX - target.offsetLeft - radius}px`;
    circle.style.top = `${event.clientY - target.offsetTop - radius}px`;
    circle.classList.add('ripple');
    const ripple = target.getElementsByClassName('ripple')[0];
    circle.style.backgroundColor = rippleColor;
    // ripple.style.backgroundColor = rippleColor;
    if (ripple) {
      ripple.remove();
    }
    target.appendChild(circle);
  }, [rippleColor]);

  const handleClick = useCallback((e: any) => {
    createRipple(e);
    if (onClick) {
      onClick(e);
    }
  }, [onClick, createRipple]);

  return (
    <Flex
      direction="column"
      onClick={handleClick}
      className={classNames('ripple-box', className)}
      {...rest}>
      {children}
    </Flex>
  );
}

export default Ripple;
